import * as React from 'react';
import { styles } from './styles';
import { DemoSection, DemoSectionProps } from '../components/DemoSection';
import { SelectableOption } from '../../SelectableOption';
import { capitalize } from 'utils/strings';
import { MoreOptionsMessage } from '../../MoreOptionsMessage';
import { DemoFontOptionKey } from '../../../types';
import { PREVIEW_FONT_KEYS } from '../../../constants';
import { supportedFontFamily } from '@routes/event/guest/services/fonts/fontService';

const MESSAGE = 'Hundreds more to choose from after getting started with this design.';

const renderLayoutOptions = (
  currentFont: Props['font'],
  onClick: Props['onFontSelect'],
  fontOptions: DemoFontOptionKey[]
) => {
  return (
    <div className={styles.container}>
      {fontOptions.map(font => {
        return (
          <SelectableOption
            key={font}
            section="fonts"
            value={font}
            onClick={onClick}
            className={styles.optionContainer}
          >
            <div className={styles.testText(font)}>Romeo &amp; Juliet</div>
            <div className={styles.fontName}>{capitalize(font)}</div>
          </SelectableOption>
        );
      })}
    </div>
  );
};

interface Props extends DemoSectionProps {
  font: DemoFontOptionKey;
  onFontSelect: React.MouseEventHandler<HTMLElement>;
  onStartClick: React.MouseEventHandler<HTMLElement>;
  customFont: string | null;
}

export const FontDesign: React.SFC<Props> = ({
  open,
  font,
  onFontSelect,
  onSectionToggle,
  onStartClick,
  customFont
}) => {
  const fontOptions: DemoFontOptionKey[] = customFont
    ? [supportedFontFamily(customFont), ...PREVIEW_FONT_KEYS]
    : PREVIEW_FONT_KEYS;

  return (
    <DemoSection
      open={open}
      onSectionToggle={onSectionToggle}
      section="fonts"
      name="Change Wedding Font"
      subtitle={capitalize(font)}
    >
      {renderLayoutOptions(font, onFontSelect, fontOptions)}
      <MoreOptionsMessage id={'font'} message={MESSAGE} onClick={onStartClick} />
    </DemoSection>
  );
};
